<template><div></div></template>
<script>
  export default {
    props: {
      interceptor: {
        type: Boolean,
        required: true
      }
    },

    emits: ['isValid'],

    mounted() {
      this.$emit('isValid', this.interceptor);
    },

    watch: {
      interceptor(newVal) {
        this.$emit('isValid', newVal);
      }
    }
  };
</script>
